/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegerResource
 */
export interface IntegerResource {
    /**
     * 
     * @type {number}
     * @memberof IntegerResource
     */
    value?: number;
}

/**
 * Check if a given object implements the IntegerResource interface.
 */
export function instanceOfIntegerResource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegerResourceFromJSON(json: any): IntegerResource {
    return IntegerResourceFromJSONTyped(json, false);
}

export function IntegerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegerResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function IntegerResourceToJSON(value?: IntegerResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

